import * as React from 'react';
export class ValueOrDash extends React.Component<{
    value?: number | boolean | string;
}> {
    render() {
        const { children, value } = this.props;
        return <div>{value !== undefined ? children : '–'}</div>;
    }
}
